import React, {Component} from 'react';
import { Container, Row, Col } from "reactstrap";

class Footer extends Component {
	constructor(props) {
        super(props);
        this.state={
            isReady:false,
        }
    }

    componentDidMount() {
        if(!this.state.isReady){
            this.setState({
                isReady:true
            });
        }
    }

    render() {
        return(
        	<React.Fragment>
        		<footer className="footer">
	                <Container fluid={true}>
	                    <Row>
	                        <Col md={6}>
	                            {new Date().getFullYear()} ©.
	                        </Col>
	                        <Col md={6}>
	                            <div className="text-sm-right d-none d-sm-block">
	                                
	                            </div>
	                        </Col>
	                    </Row>
	                </Container>
	            </footer>
        	</React.Fragment>
        )
    }


}
export default Footer;